import { Footer, Header, SkipLink } from '@hbo/ui-servicing-react-components';
import { PageAnalytics } from 'components';
import { ErrorBoundary, RouteChangeListener } from 'containers';
import useAuth from 'hooks/useAuth';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

function AppWrapper() {
  const { t } = useTranslation();
  const { isAuthenticated, logout } = useAuth();

  const navItems = [
    {
      title: t('generic.headerOption1'),
      href: '#',
      onClick: () => {
        // to add adobe analytics tracking
      }
    },
    {
      title: t('generic.headerOption2'),
      href: '#',
      onClick: () => {
        // to add adobe analytics tracking
      }
    },
    {
      title: t('generic.headerOption3'),
      href: '#',
      onClick: () => {
        // to add adobe analytics tracking
      }
    }
  ];

  return (
    <>
      <PageAnalytics />
      <SkipLink />
      <Header
        isAuthenticated={isAuthenticated}
        onLogout={logout}
      />
      <ErrorBoundary>
        <RouteChangeListener>
          <main style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
            <Outlet />
          </main>
        </RouteChangeListener>
      </ErrorBoundary>
      <Footer />
    </>
  );
}

export default AppWrapper;
